import * as types from "../../mutation-types";
import {removeItem, addOrUpdateItem} from "../../helpers";

export default {
    [types.ATTACH_PROJECT_CONTACT]: (state, item) => addOrUpdateItem(state, item, ['contact_id', 'project_id']),
    [types.DETACH_PROJECT_CONTACT]: (state, item) => removeItem(state, item, ['contact_id', 'project_id'])
}
